function setObjectByPath(object, path, value) {
    const keys = path.split('.');
    let current = object;
    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        if (current[key] === undefined) {
            current[key] = {}; // Create a new object if the path does not exist
        }
        current = current[key];
    }
    // Set the final key to the value
    current[keys[keys.length - 1]] = value;
    return keys[0];
}

export default setObjectByPath;
